import { OnInit, Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { DialogService } from '../../../dialog/dialog.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { DashboardService } from '../../services/dashboard.service';
import { UtilService } from 'src/modules/base/services/util.service';
import * as CryptoJS from 'crypto-js';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
declare var jQuery;

@Component({
    selector: 'avighna-result',
    templateUrl: './avighna-result.component.html',
    styleUrls: ['./avighna-result.component.scss'],
    standalone: false
})
export class AvighnaResultComponent implements OnInit {

  config: any = {isRefer:false};
  constructor(private baseService: BaseService, 
    private appService: AppService, 
    private auth: AuthenticationService, 
    private loader: LoaderService,
    public router: Router,
    public route: ActivatedRoute,
    public dialogService:DialogService,
    public storage: StorageService,
    public alerts: AlertsService,
    public utilService:UtilService,
    public dashBoardService:DashboardService
    ) {
  }

  ngOnInit() {
    var key = "ai_assessment";
   
    this.storage.getData(key,(data)=>{
      if(data){
        this.config = data;
        if(this.route.snapshot.queryParams['is_refer']){
          this.config.isRefer = true;
        }
        this.config.isBlob = true;
        this.storage.removeData(key,()=>{});
      }else{
        this.router.navigate(["/"])
      }
    })
  }


  ngOnDestroy(){
  }

  bookAppointment(){
    this.router.navigate(["/appointment/searchdoctor/individual/opd/0/"+this.config.splCode])
  }

  getUhid(){
    var uHId = this.route.snapshot.queryParams['uhId'];
    if(uHId == null){
      uHId = this.route.snapshot.params['uhId']; 
    }
    if(uHId == null){
      uHId = localStorage.getItem('hasUhId');
    }
    return uHId;
  }

  getUserID(){
    if (this.auth.getUserType() != "patient") {
        return this.route.snapshot.queryParams['user_id']
    }else{
      return this.baseService.authenticationService.getCurrentUser().user_id;
    }
  }

  referralRequest(){
    var uHId = this.getUhid();
    var queryMap = {
      key:this.route.snapshot.queryParams['id'],
      banner:JSON.stringify({
            "selector": "emr-patient-layout",
            "datasource": {
                "application": "appointment",
                "resource": "appointment",
                "query_id": "get_patient_data_for_appointment"
            },
            "jsonName": "banner_op_emr"
        }),
      is_refer:1,
      returnUrl: "/emr/patientlist_format/list"
    }
    var url = "/emr/emr_refer/add";
    this.router.navigate([url],{queryParams:queryMap})
  }
  
}
